export default {
  en: {
    title: 'Segments',
    subtitle: 'List of account segments for distribute the calls.',
    columns: {
      name: 'Name',
      channels: 'Channels',
      users: 'Team',
    },
    form: {
      infoAlert: {
        message: 'Search information',
        description: 'Can you search by first, last name, username or email, writing in the input.',
      },
      name: {
        error: 'Please fill the name of segment.',
        help: 'This is the name that customers see.',
      },
      channels: {
        error: '',
        help: 'Select where do you want this segment show.',
      },
      baseForm: {
        label: 'Base Form',
        hint: 'This form will be show, when your agents are connected.',
      },
      contactForm: {
        label: 'Contact Form',
        hint: 'This form will be show, when your agents aren\'t connected.',
      },
      surveyForm: {
        label: 'Survey',
        hint: 'Add your custom survey to this segment.',
      },
      segmentVisibility: {
        label: 'Visibility',
        hint: 'Select visible to leave it visible in all integrations',
      },
      recordingSetting: {
        label: 'Recording setting',
        hint: 'Choose the recording setting for this segment'
      },
      agentForm: {
        label: 'Agent form',
        hint: 'Form will be filled by the agent'
      },
      alertCaptchaForms: {
        label: 'You must configure captcha in "Settings" and then in "Forms". Then you can select a base (after calling) or contact form.'
      },
      externalUrl: {
        placeholder: 'Enter a link'
      },
      javascriptEvent: {
        placeholder: 'Set a string as argument',
      },
      requestLocation: {
        label: 'Request location using GPS',
        hint: 'This will use GPS of the customers\' devices for high precision location. Consider this will show a popup requesting the location permission.',
      },
      mandatoryTags: {
        label: 'Mandatory tags',
        hint: 'Restricts hanging up the call only if at least 1 tag has been selected. This does not apply to transfers.',
      },
      restrictionStatus: {
        label: 'Restriction status',
        hint: 'Restricts the quantity of calls a customers can make in a period of time.',
      },
    },
    filters: {
      text: 'Search segment by name',
      label: 'Filters',
    },
    types: {
      classic: 'Classic',
      event: 'Event',
    },
    emptyAgents: 'This segment is public without assigned agents',
    segmentEdited: 'Successfully edited segment',
    segmentCreated: 'Successfully created segment',
    addArgument: 'Add an argument',
    publicTooltip: 'This segment is visible across integrations',
    hiddenTooltip: 'This segment is hidden across integrations, but can use it with the ID',
    massive: {
      button: 'Bulk actions',
      actions: { agents: 'Assign agents to segments', dynamic: 'Assign settings to segments' },
      action: { label: 'Bulk action', removeAlert: 'Warning, the agents will be removed from the selected segments' },
      path: { label: 'Setting to change' },
      selectAll: 'Select all',
      clearSelection: 'Clear selection',
      loadingAll: 'Loading all segments…',
      selectedCount: '{count} segments selected',
      moreTags: '+ {count} more',
    },
  },
  es: {
    title: 'Segmentos',
    subtitle: 'Listado de segmentos para distribuir las llamadas.',
    columns: {
      name: 'Nombre',
      channels: 'Canales',
      users: 'Equipo',
    },
    form: {
      infoAlert: {
        message: 'Información de búsqueda',
        description: 'Podrás buscar por nombre, apellido, nombre de usuario o email del agente, en la caja de selección.',
      },
      name: {
        error: 'Por favor ingrese el nombre del segmento.',
        help: 'Este el es el nombre que los clientes visualizan.',
      },
      channels: {
        error: '',
        help: 'Seleccione dónde quiere que se muestre este segmento.',
      },
      baseForm: {
        label: 'Formulario base',
        hint: 'Este formulario se mostrará cuando hayan agentes conectados',
      },
      contactForm: {
        label: 'Formulario de contacto',
        hint: 'Este formulario se mostrará cuando no hayan agentes conectados',
      },
      surveyForm: {
        label: 'Encuesta',
        hint: 'Añade una encuesta personalizada.',
      },
      segmentVisibility: {
        label: 'Visibilidad',
        hint: 'Selecciona visible para dejar visible en todas las integraciones',
      },
      recordingSetting: {
        label: 'Ajuste de grabación',
        hint: 'Seleccione un ajuste de grabación para este segmento'
      },
      agentForm: {
        label: 'Formulario de agente',
        hint: 'Formulario que será rellenado por sus agentes durante una llamada'
      },
      alertCaptchaForms: {
        label: 'Debes configurar captcha en "Configuración" y luego en "Formularios", antes de poder seleccionar un formulario base (previo llamada) o de contacto.'
      },
      externalUrl: {
        placeholder: 'Ingrese una URL'
      },
      javascriptEvent: {
        placeholder: 'Define un argumento como texto',
      },
      requestLocation: {
        label: 'Solicitar ubicación por GPS',
        hint: 'Esto usará el GPS del dispositivo para obtener una pisición precisa. Debes considerar que esto mostrará un popup solicitando los permisos de ubicación.',
      },
      mandatoryTags: {
        label: 'Etiquetas obligatorias',
        hint: 'Restringe colgar la llamada solo si se ha seleccionado al menos 1 etiqueta. Esto no aplica para transferencias.',
      },
      restrictionStatus: {
        label: 'Estado de restricción',
        hint: 'Restringe la cantidad de llamadas que un cliente puede realizar en un período de tiempo.',
      },
    },
    filters: {
      text: 'Buscar segmento por nombre',
      label: 'Filtros',
    },
    types: {
      classic: 'Clásico',
      event: 'Evento',
    },
    emptyAgents: 'Este segmento está público y sin agentes asignados',
    segmentEdited: 'Segmento editado correctamente',
    segmentCreated: 'Segmento creado correctamente',
    addArgument: 'Añadir un argumento',
    publicTooltip: 'Este segmento está visible en las integraciones',
    hiddenTooltip: 'Este segmento está oculto en las integraciones, pero puedes usarlo mediante el ID',
    massive: {
      button: 'Acciones por lote',
      actions: { agents: 'Asignar agentes a segmentos', dynamic: 'Asignar ajustes a segmentos' },
      action: { label: 'Acción masiva', removeAlert: 'Advertencia, los agentes se quitarán de los segmentos seleccionados' },
      path: { label: 'Ajuste a modificar' },
      selectAll: 'Seleccionar todos',
      clearSelection: 'Limpiar selección',
      loadingAll: 'Cargando todos los segmentos…',
      selectedCount: '{count} segmentos seleccionados',
      moreTags: '+ {count} más',
    },
  },
  fr: {
    title: 'Segments',
    subtitle: 'Liste des segments de compte pour distribuer les appels.',
    columns: {
      name: 'Nom',
      channels: 'Canaux',
      users: 'Équipe',
    },
    form: {
      infoAlert: {
        message: 'Rechercher des informations',
        description: 'Vous pouvez rechercher par prénom, nom, nom d\'utilisateur ou email en écrivant dans le champ.',
      },
      name: {
        error: 'Veuillez remplir le nom du segment.',
        help: 'C\'est le nom que les clients voient.',
      },
      channels: {
        error: '',
        help: 'Sélectionnez où vous souhaitez que ce segment soit affiché.',
      },
      baseForm: {
        label: 'Formulaire de base',
        hint: 'Ce formulaire sera affiché lorsque vos agents sont connectés.',
      },
      contactForm: {
        label: 'Formulaire de contact',
        hint: 'Ce formulaire sera affiché lorsque vos agents ne sont pas connectés.',
      },
      surveyForm: {
        label: 'Sondage',
        hint: 'Ajoutez votre sondage personnalisé à ce segment.',
      },
      segmentVisibility: {
        label: 'Visibilité',
        hint: 'Sélectionnez visible pour le laisser visible dans toutes les intégrations',
      },
      recordingSetting: {
        label: 'Paramètre d\'enregistrement',
        hint: 'Choisissez le paramètre d\'enregistrement pour ce segment'
      },
      agentForm: {
        label: 'Formulaire agent',
        hint: 'Formulaire rempli par l\'agent'
      },
      alertCaptchaForms: {
        label: 'Vous devez configurer le captcha dans "Paramètres" puis dans "Formulaires". Ensuite, vous pouvez sélectionner un formulaire de base (après l\'appel) ou un formulaire de contact.'
      },
      externalUrl: {
        placeholder: 'Entrez un lien'
      },
      javascriptEvent: {
        placeholder: 'Définir une chaîne comme argument',
      },
      requestLocation: {
        label: 'Demander la localisation via GPS',
        hint: 'Cela utilisera le GPS des appareils des clients pour une localisation de haute précision. Notez que cela affichera une popup demandant l\'autorisation de localisation.',
      },
      mandatoryTags: {
        label: 'Tags obligatoires',
        hint: 'Restreint la fin de l\'appel uniquement si au moins 1 tag a été sélectionné. Cela ne s\'applique pas aux transferts.',
      },
      restrictionStatus: {
        label: 'Statut de restriction',
        hint: 'Restreint le nombre d\'appels qu\'un client peut passer sur une période donnée.',
      },
    },
    filters: {
      text: 'Rechercher un segment par nom',
      label: 'Filtres',
    },
    types: {
      classic: 'Classique',
      event: 'Événement',
    },
    emptyAgents: 'Ce segment est public sans agents assignés',
    segmentEdited: 'Segment modifié avec succès',
    segmentCreated: 'Segment créé avec succès',
    addArgument: 'Ajouter un argument',
    publicTooltip: 'Ce segment est visible à travers les intégrations',
    hiddenTooltip: 'Ce segment est caché à travers les intégrations, mais peut être utilisé avec l\'ID',
    massive: {
      button: 'Actions par lot',
      actions: { agents: 'Affecter des agents à des segments', dynamic: 'Affecter des paramètres à des segments' },
      action: { label: 'Action massive', removeAlert: 'Attention, les agents seront supprimés des segments sélectionnés' },
      path: { label: 'Paramètre à modifier'},
      selectAll: 'Tout sélectionner',
      clearSelection: 'Effacer la sélection',
      loadingAll: 'Chargement de tous les segments…',
      selectedCount: '{count} segments sélectionnés',
      moreTags: '+ {count} de plus',
    },
}

};
